import { contactFormParametersGeneration } from './contactFormParametersGeneration'
import { contactSaveParametersGeneration } from './IT/contactSaveParametersGeneration'
import type { ContactSubscriptionData } from './contactSubscriptionData'

type GenerateContactParametersParams = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
  gryvChecklistCheckedTitles: Record<string, boolean>
}

type ContactParametersGenerator = (params: Omit<GenerateContactParametersParams, 'gryvChecklistCheckedTitles'>) => URLSearchParams

const parametersGeneratorByCountry: Record<string, ContactParametersGenerator> = {
  it: contactSaveParametersGeneration,
}

export function generateContactParameters({
  contactData,
  id,
  country,
  action,
  gryvChecklistCheckedTitles,
}: GenerateContactParametersParams): URLSearchParams {
  const generator = parametersGeneratorByCountry[country]

  if (generator) {
    return generator({ contactData, id, country, action })
  }

  return contactFormParametersGeneration({ contactData, id, country, action, gryvChecklistCheckedTitles })
}
